import { ChangeEvent, FC, useState } from 'react'
import classNames from 'classnames'

import { PreviousAndNextButton } from '@/compositions/@buttons/PreviousAndNextButton/PreviousAndNextButton'
import { validatePasswordRegistrationData } from '@/compositions/RegistrationFlow/helpers/validateFormData'
import { UserFormData } from '@/entities/User/User'
import { useCapslock } from '@/helpers/hooks/useCapsLock'
import { isObjEmpty } from '@/helpers/tools'
import { trans } from '@/helpers/trans'

import './PasswordRegistration.scss'


interface PasswordRegistrationProps {
    values: UserFormData
    onChange: (formData: Partial<UserFormData>) => void
    onPreviousStep: () => void
    onNextStep: () => void
    className?: string
    inputClassName?: string
}

export const PasswordRegistration: FC<PasswordRegistrationProps> = ({
    values,
    onChange,
    onPreviousStep,
    onNextStep,
    className = '',
    inputClassName = '',
}) => {
    const isCapsLockPressed = useCapslock()

    const [submitted, setSubmitted] = useState(false)
    const validationErrors = validatePasswordRegistrationData(values, submitted, isCapsLockPressed)

    const onNextStepClick = () => {
        setSubmitted(true)
        if (isObjEmpty(validatePasswordRegistrationData(values, true))) {
            onNextStep()
        }
    }

    const onChangePassword = (e: ChangeEvent<HTMLInputElement>) => {
        onChange({ password: e.target.value })
    }

    const onChangePasswordRepeat = (e: ChangeEvent<HTMLInputElement>) => {
        onChange({ passwordRepeat: e.target.value })
    }

    return (
        <div className={`password-registration ${className}`}>
            <h4 className="password-registration__title">{trans('pages.registration.passwordTitle')}</h4>
            <div className="password-registration__modal-body">
                <p>
                    {trans('pages.registration.passwordIntro')}
                </p>
                <div className="password-registration__row">
                    <div className="password-registration__col">
                        <div className="form-group">
                            <label>{trans('common.password')}</label>
                            <input
                                className={classNames('form-control', inputClassName, { 'is-invalid': !! validationErrors.password })}
                                type="password"
                                name="password"
                                id="password"
                                placeholder={trans('pages.registration.enterPassword')}
                                defaultValue={values.password}
                                onChange={onChangePassword}
                            />
                            <div className="invalid-feedback">
                                { validationErrors.password }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="password-registration__row">
                    <div className="password-registration__col">
                        <div className="form-group">
                            <label>{`${trans('common.confirm')} ${trans('common.password')}`}</label>
                            <input
                                className={classNames('form-control', inputClassName, { 'is-invalid': !! validationErrors.passwordRepeat })}
                                type="password"
                                name="passwordRepeat"
                                id="password-repeat"
                                placeholder={trans('pages.registration.repeatPassword')}
                                defaultValue={values.passwordRepeat}
                                onChange={onChangePasswordRepeat}
                            />
                            <div className="invalid-feedback">
                                { validationErrors.passwordRepeat }
                            </div>
                        </div>
                    </div>
                </div>
                <PreviousAndNextButton onPreviousStep={onPreviousStep} onNextStep={onNextStepClick} />
            </div>
        </div>
    )
}
